import React from 'react';
import { Tag } from 'antd';

/**
 * "Invited" marks a person who has been invited but has not accepted yet. It
 * follows the API's `user.invited` flag alone, so it disappears the moment the
 * invitee accepts and the next read no longer carries the flag.
 */
export default function InvitedTag({ user }) {
	if (!user?.invited) return null;
	return <Tag className="invited-tag" data-testid="invited-tag">Invited</Tag>;
}
